import { buildModalViewDisplayedPayload } from '../buildPayloads/buildModalViewDisplayedPayload.js';
export const trackModalView = (params) => {
    return buildModalViewDisplayedPayload(params);
};
//# sourceMappingURL=trackModalView.js.map